import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ServerLogsState {
  isLoading: boolean;
  parsedLogs: any[];
  error: string | null;
}

const initialState: ServerLogsState = {
  isLoading: false,
  parsedLogs: [],
  error: null,
};

const serverLogsSlice = createSlice({
  name: 'serverLogs',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setParsedLogs: (state, action: PayloadAction<any[]>) => {
      state.parsedLogs = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    resetServerLogsState: state => {
      state.isLoading = false;
      state.parsedLogs = [];
      state.error = null;
    },
  },
});

export const { setIsLoading, setParsedLogs, setError, resetServerLogsState } =
  serverLogsSlice.actions;
export default serverLogsSlice.reducer;
